import React from 'react';

import { CarRentalPartners, CarRentalFeatures, CarRentalSteps } from './';
import styles from './CarRentalsStaticContent.module.scss';

const CarRentalStaticContent: React.FC = () => {
  return (
    <div className={styles.container}>
      <CarRentalPartners />
      <CarRentalFeatures />
      <CarRentalSteps />
    </div>
  );
};

export default CarRentalStaticContent;
